/* eslint-disable perfectionist/sort-enums */
import { ISelectOption, TSelectValues } from '@private/components';
import { IDateBlockerChecker, IDatepickerProps } from '@private/datepicker';

import { ANALYTIC_FILTER_OPERATIONS } from 'components/Form/FormikFiltersSection/constant';
import { INullable } from 'utils/types';

export type IAdditionalCondition = Pick<
  IAppliedFilterValue,
  'disabledIndexes' | 'enabled' | 'operation' | 'value'
>;

export type IAppliedFilter = Record<string, IAppliedFilterValue>;

export interface IAppliedFilterValue {
  additionalCondition?: IAdditionalCondition;
  disabledIndexes?: number[];
  enabled?: boolean;
  ignoreCase?: boolean;
  index?: number;
  operation?: INullable<FILTER_OPERATIONS>;
  value?: IFilterValue;
}

export interface IDateRange {
  max: Date;
  min: Date;
}

export type IFallbackValues = Record<string, () => IAppliedFilterValue>;

export interface IFilter {
  additionalCondition?: IAdditionalCondition;
  disabledIndexes?: number[];
  enabled?: boolean;
  label?: string;
  operation?: INullable<ANALYTIC_FILTER_OPERATIONS | FILTER_OPERATIONS>;
  value?: IFilterValue;
}

export type IFilterValue =
  | IDateRange
  | INumberRange
  | IScopeValue
  | ISelectOption
  | ISelectOption[]
  | string[]
  | TSelectValues;

export interface IMerchantScope {
  fullAccess: boolean;
  id: INullable<number>;
  merchantTerminals: number[];
}

export interface INumberRange {
  max: string;
  min: string;
}

export interface IScopeValue {
  fullAccess: boolean;
  merchants: IMerchantScope[];
}

export type ISearchFilters = Record<string, IFilter>;

export const NOT_EQUALS_NULL_VALUE = '*';

export enum FILTER_OPERATIONS {
  MORE_OR_EQUALS = '>',
  LESS_OR_EQUALS = '<',
  EQUALS = ':',
  NOT_EQUALS = '!',
  EQUALS_NULL = ':*null',
  NOT_EQUALS_NULL = '!*null',
  LIKE = '~',
  NOT_LIKE = '!~',
  CONTAINS = '&',
  IN = '#',
  NOT_IN = '!#',
  RANGE = '<>',
}

export enum NAVIGATION_ACTION {
  PER_PAGE,
  PAGE,
  FILTER,
  SORT,
  ALL,
  PRESET,
}

export type IDatePickerConfig = Partial<
  IDatepickerProps & {
    availableDaysChecker?: IDateBlockerChecker;
  }
>;

export interface IOpenSidebarParams {
  columnKey: string;
  index?: number;
  isAdditional?: boolean;
}

export interface IPresetForm {
  name: string;
}

export type ISelectFilterProps = IAppliedFilterValue & {
  columnKey: string;
  immediateApply?: boolean;
  isAdditional?: boolean;
};

export type ISelectOperationCb = (data: {
  columnKey: string;
  operation?: FILTER_OPERATIONS;
}) => void;

export interface ISelectOperationProps {
  columnKey: string;
  operation?: INullable<FILTER_OPERATIONS>;
}

export interface IToggleAdditionalConditionProps {
  columnKey: string;
  operation: FILTER_OPERATIONS;
}
